<script>
import {mixin_page_table} from "@/utils/mixin";
import {getListSync} from "@/api/log-api";

export default {
  name: "SyncLogPage",
  mixins: [mixin_page_table],
  data() {
    return {
      tableHeader: [
        {prop: 'id', label: '序号', width: 100, type: 0},
        {prop: 'timedHour', label: '定时器时间', width: 180, type: 2},
        {prop: 'execResult', label: '执行结果', width: '', type: 3},
        {prop: 'beginTime', label: '开始时间', width: 200, type: 1},
        {prop: 'endTime', label: '结束时间', width: 200, type: 1},

      ],
    }
  }, // data end

  mounted() {
    this.refreshTableData()
  },

  methods: {
    refreshTableData() {
      this.tableData = []
      let pageIndex = this.curPageIndex
      let pageSize = this.curPageSize
      getListSync(pageIndex, pageSize).then(({data}) => {
        console.log("getListSms", data)
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals

        } else {
          this.$message.error(data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
      })
    },
  },

  filters: {
    formatTime(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(-2);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    formatResult(result) {
      switch (result) {
        case "SUCCESS":
          return "执行成功"
        case "RUNNING":
          return "执行中"
        default:
          return "失败"
      }
    },
  },

}
</script>

<template>
  <div>
    <div style="margin-bottom: 10px">
    </div>
    <el-table :data="tableData" border>
      <el-table-column v-for="(headerItem) in tableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                       :width="headerItem.width" :label="headerItem.label">
        <template v-slot="scope">
          <template v-if="headerItem.type === 1">{{ scope.row[headerItem.prop] | formatTime }}</template>
          <template v-else-if="headerItem.type === 3">{{ scope.row[headerItem.prop] | formatResult }}</template>
          <template v-else-if="headerItem.type === 2">
            <el-tag v-if="scope.row[headerItem.prop] === '-1'">手动同步</el-tag>
            <el-tag v-else>每天{{ scope.row[headerItem.prop] }}点</el-tag>
          </template>
          <template v-else>{{ scope.row[headerItem.prop] }}</template>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager">
      <el-pagination layout="sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                     :page-size.sync="curPageSize" :pager-count="5"
                     :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped lang="less">

</style>
